import Activities from '@/components/Activities'
import { getCustomerLogs } from '@/modules/Customer/services'
import { useParams } from 'react-router-dom'
import { Typogaphy } from 'vnetwork-ui'
import { useTranslation } from 'react-i18next'
import Paper from '@/components/Paper'

const CustomerLogs = () => {
    const { id } = useParams()
    const { t } = useTranslation()
    return (
        <Paper className="mt-2">
            <Typogaphy className="text-sm font-medium text-gray-700">
                {t('activity_logs.title')}
            </Typogaphy>
            <Activities
                className="space-y-2"
                apiCall={(payload) =>
                    getCustomerLogs({
                        customer_id: Number(id),
                        params: payload,
                    })
                }
                queryKey={`customer-logs-${Number(id)}`}
            />
        </Paper>
    )
}

export default CustomerLogs
